import Script from "next/script";

export const TrueFitScript = () => {
    const environment = process.env.NEXT_PUBLIC_ENVIRONMENT === "production" ? "prod" : "staging";

    const trueFitScript = `(function(r,e,o){
                var w=window,d=document,t,s,x;
                w.tfcapi=t=w.tfcapi||function(){t.q=t.q||[]; t.q.push(arguments);};
                t('init', {storeKey: r, environment: e, ...o});
                x=d.getElementsByTagName('script')[0];
                s=d.createElement('script');
                s.type='text/javascript';s.async=true;
                s.src='https://'+r+'-cdn'+(e==='dev'||e==='staging'?'.'+e:'')+ '.truefitcorp.com/fitrec/global/js/tf-integration.js?storeKey='+r;
                x.parentNode.insertBefore(s,x);
                // Don't change anything above this line
                })('eoc', '${environment}', {autoCalculate: false});
            `;

    return (
        <Script id="truefit-script" strategy="afterInteractive" type="text/javascript">
            {trueFitScript}
        </Script>
    );
};
